const scrollToElement = (element, { top } = {}) => {
	const offset = top || 0
	/* eslint-disable */
	const bodyRect = document.body.getBoundingClientRect().top
	const elementRect = element.getBoundingClientRect().top
	/* eslint-enable */
	const elementPosition = elementRect - bodyRect
	const offsetPosition = elementPosition - offset

	window.scrollTo({
		top: offsetPosition,
		behavior: 'smooth'
	})
}

export default scrollToElement
